import { useMemo } from 'react';
import { useAppSelector } from 'store/hook';
import { isDarkTheme } from 'utils/theme';

const useAppTheme = () => {
  const theme = useAppSelector((state) => state.authReducer).customer.theme;
  const enableDarkTheme = useMemo(() => isDarkTheme(theme), [theme]);
  return { enableDarkTheme };
};

export default useAppTheme;
